export default __webpack_public_path__ + "static/subscribe-banner-2-47d8513c98d2418a538c7572063665ca.png";